import { Divider, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Create, SimpleForm, TextInput, SelectInput, required, DateInput, AutocompleteInput, useRedirect, useNotify, RadioButtonGroupInput, FileInput, FileField } from "react-admin";
import { getNameAndCompanyNamewithAddress } from "../common";
import { useLocation } from "react-router-dom";

const ConstructHistoryCreate = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const redirect = useRedirect();
  const notify = useNotify();
  const [customers,setCustomers]=useState([]);
  const [customerId,setCustomerId]=useState(searchParams.get("customer"));
  const [invoiceHistory,setInvoiceHistory] =useState([]);
  const [isNew, setisNew] = useState(-1); 
  const [isPay,setIsPay] = useState(0);
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_DIR}/customers/construct`, {
          method: "GET",
          headers: new Headers({ "Content-Type": "application/json" }),
          mode: "cors",
          credentials: "include",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch user info");
        }
        const { data } = await response.json();
        setCustomers(data);
      } catch (error) {
        console.error("ユーザー情報の取得に失敗しました:", error);
      } finally {
        // setLoading(false);
      }
    };
    fetchUser();
  }, []);

  useEffect(()=>{
    const fetchInvoice = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_DIR}/invoiceHistory/customer/${customerId}`, {
          method: "GET",
          headers: new Headers({ "Content-Type": "application/json" }),
          mode: "cors",
          credentials: "include",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch user info");
        }
        const { data } = await response.json();
        console.log(data);
        setInvoiceHistory(data);
      } catch (error) {
        console.error("ユーザー情報の取得に失敗しました:", error);
      } finally {
        // setLoading(false);
      }
    };

    if(customerId){
      fetchInvoice();
    }
  },[customerId])

  return (
    <>
    {customers &&
      <Create mutationMode="pessimistic"
        mutationOptions={{ 
          onSuccess: () => {
            notify('作成が完了しました', { type: 'success' }); 
            // redirect('list', 'constructHistory');
            window.history.back();
          }
        }}
      >
      <SimpleForm
        onKeyDown={e => {
          if (e.key === 'Enter') {
              e.preventDefault();
          }
        }}
      >
        <AutocompleteInput
            source="customerId"
            label="顧客名"
            choices={customers.map(req => ({
              id: req.id, 
              name: `${getNameAndCompanyNamewithAddress(req)}`
            }))}
            onChange={(e) => setCustomerId(e)}
            defaultValue={customerId}
            validate={required()}
            allowEmpty
            freeSolo  
          />  
          <DateInput source="constructDate" label="修理日" inputProps={{ max: '9999-12-31' }}/>
          <TextInput source="content" label="修理内容" multiline rows={5}/>
          <TextInput source="staffName" label="担当者名"/>
          <FileInput source="pictureURL" label="工事写真" accept="image/*">
            <FileField source="src" title="title" />
          </FileInput>
          {/* <SelectInput 
            source="isNew"
            label="請求情報"
            choices={[
              { id: -1, name: "後から追加" },
              { id: 1, name: "新規追加" },
              { id: 0, name: "請求履歴から選択" }
            ]}
            validate={required()}
            defaultValue={-1}
            onChange={(e) => setisNew(e.target.value)}
          />
           {isNew === -1 ? (
            <></>
           ) : (
            <> */}
            <Divider sx={{ my: 2 }} /> {/* セクション区切り */}
            <Typography variant="h6">請求情報</Typography>
            {/* {isNew === 1 ? (
              <> */}
                <div style={{display:"flex", justifyContent:"space-between",width:"100%"}}>
                  <DateInput source="invoiceDate" label="請求日" style={{marginRight:"10px"}} inputProps={{ max: '9999-12-31' }}/>
                  <TextInput source="invoiceAmount" label="請求金額(税抜き)" style={{marginLeft:"10px",marginRight:"10px"}}/>
                  <SelectInput source="payMethod" label="支払い方法" choices={[
                      { id: "持参", name: "持参" },
                      { id: "振り込み", name: "振り込み" },
                      { id: "集金", name: "集金" }
                    ]} style={{marginLeft:"10px"}}/>
                </div>
                <DateInput source="reissueDate" label="再発行日" inputProps={{ max: '9999-12-31' }}/>
                <RadioButtonGroupInput
                  source="isPay"
                  label="領収"
                  choices={[
                    { id: 1, name: '領収済み' },
                    { id: 0, name: '未領収' }
                  ]}
                  validate={required()}
                  defaultValue={isPay}
                  onChange={(e) => setIsPay(Number(e.target.value))}
                />
                <DateInput source="receiptDate" label="領収日" disabled={!isPay} inputProps={{ max: '9999-12-31' }}/>
                <FileInput source="documentURL" label="請求書" accept="application/pdf, image/*">
                  <FileField source="src" title="title" />
                </FileInput>
              {/* </>
            ) : (
              <AutocompleteInput
                source="invoiceId"
                label="請求履歴"
                choices={invoiceHistory.map(req => ({
                  id: req.invoiceId, 
                  name: `請求No.${String(req.id).padStart(5, "0")}（請求日：${(new Date(req.invoiceDate)).toLocaleDateString('ja-JP')}）`
                }))}
                disabled={!customerId}
                allowEmpty
                freeSolo  
              />
            )}
          </>
          )} */}
        </SimpleForm>
      </Create>
    }
    </>
  )

};

export default ConstructHistoryCreate;
